import React, { useRef } from 'react';
import { Tag, Icon, Button } from 'antd';
import { useFormContext } from 'react-hook-form';

export default function AttachFiles({ disabled }) {
  const { setValue, watch } = useFormContext();
  const fileInputRef = useRef(null);

  const attachments = watch('attachments');

  const onClickAddAttachments = () => {
    fileInputRef.current.click();
  };

  const onAddAttachments = e => {
    if (disabled) return;
    const files = Array.from(e.target.files);
    const attachmentMap = {};
    [...attachments, ...(files || [])].forEach(
      file => (attachmentMap[`${file.name}/${file.size}`] = file),
    );
    setValue('attachments', Object.values(attachmentMap));
  };

  const onRemoveAttachment = index => e => {
    e.preventDefault();
    if (disabled) return;
    const newAttachments = [
      ...attachments.slice(0, index),
      ...attachments.slice(index + 1),
    ];
    setValue('attachments', newAttachments);
  };

  return (
    <div>
      <input
        disabled={disabled}
        multiple
        ref={fileInputRef}
        style={{ display: 'none' }}
        type="file"
        onChange={onAddAttachments}
      />

      <Button
        disabled={disabled}
        size="small"
        type="link"
        onClick={onClickAddAttachments}
      >
        <Icon type="plus" /> Add Attachments
      </Button>

      <div style={{ marginTop: 10 }}>
        {attachments.map((file, i) => (
          <div key={i} style={{ marginTop: 3 }}>
            <Tag closable onClose={onRemoveAttachment(i)}>
              {file.name}
            </Tag>
          </div>
        ))}
      </div>
    </div>
  );
}
